import { fetchApi } from '../client';

export interface GeneratedLogin {
  role: string;
  name: string;
  email: string;
  /** Only present on create/add-staff responses — never re-sent on a plain list/detail read. */
  password?: string;
}

export interface TestClinicSummary {
  clinicId: string;
  clinicName: string;
  createdAt: string;
  labEnabled: boolean;
  pharmacyEnabled: boolean;
  doctorCount: number;
  staffCount: number;
  patientCount: number;
  generatedLogins?: GeneratedLogin[];
}

export interface CreateTestClinicRequest {
  clinicName?: string;
  doctorCount: number;
  staffCount: number;
  includeLab: boolean;
  includePharmacy: boolean;
  patientCount: number;
  includeActivityTrail: boolean;
  /** Also creates a patient-portal login for each generated patient. */
  includePatientLogins: boolean;
}

export type AddStaffRole = 'doctor' | 'staff' | 'lab_admin' | 'lab_staff' | 'pharmacy_admin';

export interface AddStaffRequest {
  role: AddStaffRole;
  count: number;
}

export interface AddPatientsRequest {
  count: number;
  includeActivityTrail: boolean;
  /** Also creates a patient-portal login for each generated patient. */
  includePatientLogins: boolean;
}

export const testDataModule = {
  /** Test Data Studio — super_admin only, dev/UAT only (404s if disabled for the environment). */
  listTestClinics: () => fetchApi<TestClinicSummary[]>('/api/v1/test-data/clinics'),

  getTestClinic: (clinicId: string) =>
    fetchApi<TestClinicSummary>(`/api/v1/test-data/clinics/${clinicId}`),

  createTestClinic: (req: CreateTestClinicRequest) =>
    fetchApi<TestClinicSummary>('/api/v1/test-data/clinics', {
      method: 'POST',
      body: JSON.stringify(req),
    }),

  addStaff: (clinicId: string, req: AddStaffRequest) =>
    fetchApi<TestClinicSummary>(`/api/v1/test-data/clinics/${clinicId}/staff`, {
      method: 'POST',
      body: JSON.stringify(req),
    }),

  addPatients: (clinicId: string, req: AddPatientsRequest) =>
    fetchApi<TestClinicSummary>(`/api/v1/test-data/clinics/${clinicId}/patients`, {
      method: 'POST',
      body: JSON.stringify(req),
    }),

  deactivateTestClinic: (clinicId: string) =>
    fetchApi<{ message: string }>(`/api/v1/test-data/clinics/${clinicId}/deactivate`, {
      method: 'POST',
    }),
};
